import {
  AuthError,
  BrowserAuthErrorCodes,
  ClientAuthErrorCodes,
  InteractionRequiredAuthError,
} from '@azure/msal-browser';

// Refresh 5 minutes early so the current token remains a valid fallback on transient failures.
const TOKEN_EXPIRY_BUFFER_SECONDS = 300;

// invalid_grant is how the token endpoint reports an expired/revoked refresh token; MSAL does not map it to InteractionRequiredAuthError.
const TERMINAL_ERROR_CODES: ReadonlySet<string> = new Set([
  'invalid_grant',
  ClientAuthErrorCodes.tokenRefreshRequired,
  BrowserAuthErrorCodes.noAccountError,
]);

function nowInSeconds(): number {
  return Math.floor(Date.now() / 1000);
}

export function isExpiringSoon(exp: number | undefined): boolean {
  return !exp || nowInSeconds() >= exp - TOKEN_EXPIRY_BUFFER_SECONDS;
}

export function isStrictlyExpired(exp: number | undefined): boolean {
  return !exp || nowInSeconds() >= exp;
}

/** True when retrying silently cannot succeed and the user must sign in again. */
export function isTerminalAuthError(error: unknown): boolean {
  if (error instanceof InteractionRequiredAuthError) {
    return true;
  }
  return (
    error instanceof AuthError && TERMINAL_ERROR_CODES.has(error.errorCode)
  );
}

export function getAuthErrorCode(error: unknown): string {
  return error instanceof AuthError ? error.errorCode : 'unknown';
}
